export default __webpack_public_path__ + "assets/default-preview-image.0db7a541.png";